export type SeedReadReason = 'no_key' | 'decrypt' | 'reauth' | 'network';

/** Why a stored seed could not be opened.
 *  `decrypt` and `no_key` are the only reasons a caller may delete the local copy. */
export function seedReadReason(e: unknown): SeedReadReason {
  const msg = String(e);
  if (/reauth_required|pin_required|API 401\b|API 403\b/.test(msg)) return 'reauth';
  // Rate limit, timeout, 5xx, and dropped connections are retries. Only a real
  // AES failure means the ciphertext is useless — anything else must not wipe it.
  if (/API (?:408|429|5\d\d)\b|Failed to fetch|NetworkError|Load failed|AbortError/i.test(msg)) {
    return 'network';
  }
  if (/no_key|API 404\b/.test(msg)) return 'no_key';
  const name = e instanceof Error ? e.name : '';
  if (name === 'OperationError' || (typeof DOMException !== 'undefined' && e instanceof DOMException)) {
    return 'decrypt';
  }
  return 'network';
}
